import { ArrowLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTES } from "utils/constants";

import { Form } from "components/Form";
import Header from "components/Header";
import MainMenu from "components/MainMenu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/Tabs";

import Method from "./Method";
import Package from "./Package";
import Payment from "./Payment";
import useCheckout from "./useCheckout";

export default function Checkout() {
  const { t } = useTranslation();

  const { form, activeTab, changeTab, disabledTabs } = useCheckout();

  return (
    <>
      <Header className="justify-between">
        <div className="flex items-center gap-2">
          <Link to={ROUTES.HOME} className="flex items-center cursor-pointer">
            <ArrowLeftIcon />
          </Link>
          {t("menu.packageSelection")}
        </div>
        <MainMenu />
      </Header>

      <Tabs value={activeTab} className="flex-1 flex flex-col mt-6 px-4 md:px-0 mb-16 gap-6">
        <TabsList className="w-full max-w-[670px] mx-auto shrink-0">
          <TabsTrigger onClick={() => changeTab("package")} value="package">
            {t("checkout.package.title")}
          </TabsTrigger>
          <TabsTrigger
            disabled={disabledTabs.method}
            onClick={() => !disabledTabs.method && changeTab("method")}
            value="method"
          >
            {t("checkout.method.title")}
          </TabsTrigger>
          <TabsTrigger
            disabled={disabledTabs.payment}
            onClick={() => !disabledTabs.payment && changeTab("payment")}
            value="payment"
          >
            {t("checkout.payment.title")}
          </TabsTrigger>
        </TabsList>
        <Form {...form}>
          <TabsContent value="package">
            <Package />
          </TabsContent>
          <TabsContent value="method">
            <Method />
          </TabsContent>
          <TabsContent value="payment">
            <Payment />
          </TabsContent>
        </Form>
      </Tabs>
    </>
  );
}
